import React from "react";
import { useTranslation } from "react-i18next";
import { FullSplitDnsDomain } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link DeleteDomainDialog}
 */
export type DeleteDomainDialogProps = {
    /** The Domain */
    domain: FullSplitDnsDomain | undefined;
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful deletion */
    onDeletion: () => void;
};

/**
 * A dialog to delete a Domain
 */
export default function DeleteDomainDialog(props: DeleteDomainDialogProps) {
    const [t] = useTranslation("dialog-delete-split-dns");

    if (!props.domain) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.domain) return;
                await ApiInternal.dns.deleteDomainSplitDns(props.domain.uuid);
                notify.success(t("toast.successfully-deleted-domain"));
                props.onDeletion();
            }}
            title={t("heading.delete-domain")}
            description={t("description.delete-domain")}
            confirmLabel={t("button.delete")}
            cancelLabel={t("button.cancel")}
        />
    );
}
